import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpotlightFieldConditionIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.66602 8.80002C6.66602 8.05328 6.66602 7.67992 6.81134 7.3947C6.93917 7.14382 7.14315 6.93984 7.39403 6.81201C7.67924 6.66669 8.05261 6.66669 8.79935 6.66669H15.1993C15.9461 6.66669 16.3195 6.66669 16.6047 6.81201C16.8556 6.93984 17.0595 7.14382 17.1874 7.3947C17.3327 7.67992 17.3327 8.05328 17.3327 8.80002V15.2C17.3327 15.9468 17.3327 16.3201 17.1874 16.6053C17.0595 16.8562 16.8556 17.0602 16.6047 17.188C16.3195 17.3334 15.9461 17.3334 15.1993 17.3334H8.79935C8.05261 17.3334 7.67924 17.3334 7.39403 17.188C7.14315 17.0602 6.93917 16.8562 6.81134 16.6053C6.66602 16.3201 6.66602 15.9468 6.66602 15.2V8.80002Z",
		stroke: "#363636",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.0505 10H9.95079C9.64557 10 9.49296 10 9.42229 10.0827C9.36098 10.1545 9.32844 10.2622 9.33476 10.3723C9.34205 10.4993 9.44997 10.6472 9.66579 10.943L11.7156 13.7524C11.8154 13.8891 11.8653 13.9575 11.9228 13.9831C11.9734 14.0056 12.0279 14.0056 12.0785 13.9831C12.136 13.9575 12.1859 13.8891 12.2857 13.7524L14.3355 10.943C14.5513 10.6472 14.6592 10.4993 14.6665 10.3723C14.6729 10.2622 14.6403 10.1545 14.579 10.0827C14.5083 10 14.3557 10 14.0505 10Z",
		stroke: "#363636",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSpotlightFieldConditionIcon;
